import React, { FunctionComponent } from 'react';
import ShowIfTranslationExists from '../../../../../common/components/ShowIfTranslationExists';
import { Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import staticDisclaimerStyles from './staticDisclaimersStyles';
import clsx from 'clsx';

interface IStaticDisclaimerProps {
  transKey: string,
  isDisclaimerOnTop?: boolean
} 

const StaticDisclaimer: FunctionComponent<IStaticDisclaimerProps> = ({transKey, isDisclaimerOnTop}) => {
  const intl = useIntl();
  const styles = staticDisclaimerStyles({});

  return (
    <ShowIfTranslationExists translationKey={transKey}>
      <Typography
        className={clsx(styles.disclaimer, { [styles.disclaimerOnTop]: isDisclaimerOnTop })}
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({
            id: transKey,
          }),
        }}
      />
    </ShowIfTranslationExists>
  );
};

export default StaticDisclaimer;
